import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import GeoFilterCard from "./GeoFilter/GeoFilterCard";
import GeoTable from "./GeoTable/GeoTable";
import { useDispatch } from "react-redux";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

const tableHeadings = {
  name: "Geo Name",
  territory_name: "Associated Territory",
  timezone: "Time Zone",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

interface Props {
  oauthTokenHeader: any;
}

const Geo = ({ oauthTokenHeader }: Props) => {
  const [MetaGeos, setMetaGeos] = useState([]);
  const [selectedMetaGeos, setSelectedMetaGeos] = useState([]);
  const [selectedTerritory, setSelectedTerritory] = useState<string[]>([]);
  const [selectedTimezone, setSelectedTimezone] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewGeoPermissions = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_geos"
  );

  useEffect(() => {
    const fetchMetaEntitiesGeos = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaGeoDuplicate(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Geos: ", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesGeos();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewGeoPermissions) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Geo List</Typography>
            <GeoFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <GeoTable
              tableHeadings={tableHeadings}
              loading={loading}
              MetaGeos={MetaGeos}
              setMetaGeos={setMetaGeos}
              oauthTokenHeader={oauthTokenHeader}
              selectedMetaGeos={selectedMetaGeos}
              setSelectedMetaGeos={setSelectedMetaGeos}
              selectedTerritory={selectedTerritory}
              setSelectedTerritory={setSelectedTerritory}
              selectedTimezone={selectedTimezone}
              setSelectedTimezone={setSelectedTimezone}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default Geo;
